import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { useDispatch, useSelector } from 'react-redux'
import { selectors, selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { selectNavigation } from '../actions/digitalMenuActions'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'
import { colors as colorConstants } from '../constants/colors'
import { getColorPercent } from '../utils/colorUtils'
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles({
  title: {
    textAlign: 'center',
    fontFamily: 'abadi-mt-condensed-light, sans-serif',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  root: {
    minWidth: 0,
    padding: '6px',
    height: '2px'
  }
})

const NavigationTabs = (props) => {
  const selectedNavigation = useSelector(loadMenuDataSelectors.getNavigation(props.match.params[1]))
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)
  const navigations = useSelector(loadMenuDataSelectors.getNavigations)
  const dispatch = useDispatch()
  const classes = useStyles()

  const colors = useSelector(selectors.getColors)
  const secondaryColor = colors.primary && getColorPercent(colors.primary, 50)

  const handleNavigationClick = (navigation) => () => {
    dispatch(selectNavigation(navigation, storeCode))
  }

  const a11yProps = (index) => {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    }
  }

  return (<>
      {
        selectedNavigation &&
        <Tabs
          value={selectedNavigation.id}
          variant="scrollable"
          scrollButtons="on"
          className={classes.tabs}
          TabIndicatorProps={{
            style: {
              height: 0,
            }
          }}
          TabScrollButtonProps={{
            style: {
              color: colorConstants.DEFAULT_SECONDARY_FONT_COLOR,
              opacity: 0.3,
              backgroundColor: '#ffffff',
            }
          }}
        >
          {
            navigations.map((navigation, index) =>
              <Tab
                key={navigation.id}
                value={navigation.id}
                onClick={handleNavigationClick(navigation)}
                fullWidth
                classes={{
                  root: classes.root
                }}
                label={
                  <Grid
                    container
                    justify="center"
                    style={{
                      padding: '8px',
                      background: navigation.id === selectedNavigation.id ?
                        `linear-gradient(45deg, ${colors.primary} 30%, ${secondaryColor} 90%)`
                        : colorConstants.DEFAULT_SECONDARY_COLOR,
                      color: navigation.id === selectedNavigation.id ?
                        colorConstants.DEFAULT_PRIMARY_FONT_COLOR
                        : colorConstants.DEFAULT_SECONDARY_FONT_COLOR
                    }}
                  >
                    <Grid item xs={12}>
                      <Box fontSize={20} className={classes.title}>{navigation.title}</Box>
                    </Grid>
                  </Grid>
                }
                {...a11yProps(index)}
              />
            )
          }
        </Tabs>
      }
    </>
  )
}

export default NavigationTabs
